export default __webpack_public_path__ + "static/media/241.4136e3dc.png";